<template>
    <div class="text-base text-gray-600 ml-4 mr-4 flex items-center cursor-pointer hover:text-gray-700" @click="showDeletionModal=true">
        <font-awesome-icon :icon="['fas', 'trash']" /> <div class="ml-2">Delete selected</div>
        
        <jet-dialog-modal
            v-if="showDeletionModal"
            :show="showDeletionModal"
            @close="showDeletionModal = false "
        >
            <template #title>
                Delete {{ selectedNoun }}
            </template>

            <template #content>
                Are you sure you want to delete {{ selectedFormatted }} {{selectedNoun}}?
            </template>

            <template #footer>
                <button @click="modalClose">
                    Cancel
                </button>

                <jet-danger-button
                    class="ml-2"
                    @click.native="deleteItems"
                >
                    Delete {{ selectedNoun }}
                </jet-danger-button>
            </template>
        </jet-dialog-modal>
    </div>
</template>

<script>
import {mapWritableState, mapActions} from 'pinia';
import { useGeneralTableStore } from '@/Stores/general_table';

export default {
    name: 'TableActionDelete',
    data: () => ({
        showDeletionModal: false,
    }),
    computed: {
        ...mapWritableState(useGeneralTableStore, ['selected', 'selectedFormatted', 'selectedNoun', ]),
    },
    methods: {
        ...mapActions(useGeneralTableStore, ['clearData', 'fetchData']),
        deleteItems() {
            axios.post(route('template.massDelete'), {
                tra_ids: this.selected.map(item => item.tra_id)
            }).then(response => {
                this.$toasted.show(response.data, {
                    position: 'bottom-right',
                    type: 'success',
                    duration: 2000,
                });
                this.clearData();
                this.fetchData();
            })
            .catch(error => {
                const message = error.response?.data?.message || 'An error occurred';
                this.$toasted.show(message, {
                    position: 'bottom-right',
                    type: 'error',
                    duration: 2000,
                });
                console.log(error);
            })
            .finally(() => {
               this.showDeletionModal = false;
            });
        },
        modalClose() {
            this.showDeletionModal = false;
        }
    }
}

</script>